export const DEFAULT_LOCALE = "de-DE";

export const DEFAULT_CURRENCY = "EUR";

/**
 * Supported currencies in the receipt correction form.
 * smarta-banking has no shared/canonical currency set (currency is a free
 * string there), so this array is the local source of truth. Do NOT expand
 * without a corresponding back-end validation change.
 */
export const SUPPORTED_CURRENCIES = [
  DEFAULT_CURRENCY,
  "USD",
  "GBP",
  "CHF",
] as const;

export enum StatusColor {
  GOLD = "gold",
  GREEN = "green",
  ORANGE = "orange",
  PURPLE = "purple",
  GRAY = "gray",
  RED = "red",
  // Added for SMT-903 source badges (Stella, OQ-2). Both are unused elsewhere
  // in the BO, so they carry no conflicting semantics.
  BLUE = "blue",
  CYAN = "cyan",
}

export const DISPLAY_DATE_FORMAT = "DD.MM.YYYY";
export const DISPLAY_DATE_TIME_FORMAT = "DD.MM.YYYY HH:mm";
export const SAVE_DATE_FORMAT = "YYYY-MM-DD";
